/*
  Everything Babeina event hooks.
  Publishes on the Shopify analytics bus only when analytics consent allows.
  Codex maps these to GA4. Do not add a second GA4 loader here.

  babeina_hub:view        -> hub_view         hub_version, entry_type
  babeina_hub:action      -> hub_action       action_id, placement, destination_path
  babeina_hub:offer_copy  -> hub_offer_copy   result = success | failure
  babeina_hub:item_click  -> hub_item_click   product_id, product_handle, position
  babeina_hub:email_submit -> hub_email_submit method = inline_shopify
*/
if (!customElements.get('shine-hub')) {
  class ShineHub extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';
      this.viewSent = false;
      this.emailSent = false;
      this.hubVersion = this.dataset.hubVersion || 'shopify_card_v1';
      this.designMode = this.dataset.designMode === 'true' || (window.Shopify && window.Shopify.designMode);

      this.addEventListener('click', this.onClick.bind(this));
      this.loadProducts();
      this.stretchShopLogin();

      var copyButton = this.querySelector('[data-hub-copy]');
      if (copyButton) {
        copyButton.addEventListener('click', this.onCopy.bind(this));
      }

      var emailForm = this.querySelector('[data-hub-email]');
      if (emailForm) {
        emailForm.addEventListener('submitSuccess', this.onEmailSuccess.bind(this));
        var success = emailForm.querySelector('.success-msg');
        if (success && success.style.display === 'block') {
          this.onEmailSuccess();
        }
      }

      var sendView = this.sendView.bind(this);
      document.addEventListener('visitorConsentCollected', sendView);
      this.whenConsentReady(sendView);
    }

    loadProducts() {
      var slot = this.querySelector('[data-hub-arrivals]');
      var grid = this.querySelector('[data-hub-product-grid]');
      var url = this.dataset.productsUrl;
      if (!slot || !grid || !url) return;
      var self = this;

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('products');
          return response.json();
        })
        .then(function (data) {
          var html = data && data.shine_hub_products;
          if (!html || html.indexOf('shine-hub__product') === -1) return;
          grid.innerHTML = html;
          slot.hidden = false;
          self.bindArrivalsNav();
        })
        .catch(function () {});
    }

    stretchShopLogin() {
      var host = this.querySelector('shop-login-button');
      if (!host || !window.customElements || typeof CSSStyleSheet === 'undefined') return;
      var tries = 0;
      function apply() {
        var root = host.shadowRoot;
        if (!root || !root.querySelector('button')) {
          if (tries++ < 40) setTimeout(apply, 150);
          return;
        }
        try {
          var sheet = new CSSStyleSheet();
          sheet.replaceSync(':host{display:block;width:100%}button{width:100%!important}');
          root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
        } catch (e) {}
      }
      window.customElements.whenDefined('shop-login-button').then(apply);
    }

    bindArrivalsNav() {
      if (this.arrivalsNavBound) return;
      var root = this.querySelector('[data-hub-arrivals]');
      var track = this.querySelector('.shine-hub__products');
      if (!root || !track) return;
      this.arrivalsNavBound = true;

      var prevBtns = root.querySelectorAll('[data-hub-arrivals-dir="prev"]');
      var nextBtns = root.querySelectorAll('[data-hub-arrivals-dir="next"]');

      function slideWidth() {
        var slide = track.querySelector('.shine-hub__product');
        return slide ? slide.offsetWidth : 200;
      }

      prevBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: -slideWidth(), behavior: 'smooth' });
        });
      });
      nextBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
        });
      });

      var nav = root.querySelector('[data-hub-arrivals-nav]');
      if (nav) {
        var shopAllBtn = nav.querySelector('.btn');
        if (shopAllBtn && shopAllBtn.offsetHeight) {
          nav.style.setProperty('--btn-h', shopAllBtn.offsetHeight + 'px');
        }
      }
    }

    whenConsentReady(callback) {
      var shopify = window.Shopify;
      if (shopify && shopify.customerPrivacy && typeof shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        callback();
        return;
      }
      if (!shopify || typeof shopify.loadFeatures !== 'function') return;
      shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) return;
          callback();
        }
      );
    }

    analyticsAllowed() {
      if (this.designMode) return false;
      try {
        return !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed());
      } catch (error) {
        return false;
      }
    }

    entryType() {
      try {
        var params = new URLSearchParams(window.location.search);
        if (params.get('utm_source') === 'packaging' && params.get('utm_medium') === 'qr' && params.get('utm_campaign') === 'post_purchase') {
          return 'qr_tagged';
        }
      } catch (error) {}
      return 'unattributed';
    }

    destinationPath(href) {
      try {
        return new URL(href, window.location.origin).pathname;
      } catch (error) {
        return '';
      }
    }

    publish(name, payload) {
      if (!this.analyticsAllowed()) return;
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return;
      var body = payload || {};
      body.hub_version = this.hubVersion;
      analytics.publish(name, body);
      try {
        if (new URLSearchParams(window.location.search).get('hub_debug') === '1') {
          console.info('[shine-hub]', name, body);
        }
      } catch (error) {}
    }

    sendView() {
      if (this.viewSent || this.designMode) return;
      if (!this.analyticsAllowed()) return;
      this.viewSent = true;
      this.publish('babeina_hub:view', {
        entry_type: this.entryType()
      });
    }

    onClick(event) {
      var item = event.target.closest('[data-hub-track="item"]');
      if (item && this.contains(item)) {
        this.publish('babeina_hub:item_click', {
          product_id: item.getAttribute('data-product-id') || '',
          product_handle: item.getAttribute('data-product-handle') || '',
          position: item.getAttribute('data-position') || ''
        });
        return;
      }

      var action = event.target.closest('[data-hub-track="action"]');
      if (!action || !this.contains(action)) return;
      this.publish('babeina_hub:action', {
        action_id: action.getAttribute('data-action-id') || '',
        placement: action.getAttribute('data-placement') || '',
        destination_path: this.destinationPath(action.getAttribute('href'))
      });
    }

    onCopy() {
      var codeNode = this.querySelector('#shine-hub-code');
      var status = this.querySelector('[data-hub-copy-status]');
      var label = this.querySelector('[data-hub-copy-label]');
      var code = codeNode ? codeNode.textContent.trim() : '';
      var self = this;

      function finish(ok) {
        if (status) {
          status.textContent = ok ? 'Copied' : 'Select the code above to copy it';
        }
        if (ok && label) {
          var previous = label.textContent;
          label.textContent = 'Copied';
          window.setTimeout(function () {
            label.textContent = previous;
          }, 1600);
        }
        self.publish('babeina_hub:offer_copy', {
          result: ok ? 'success' : 'failure'
        });
      }

      if (!code || !navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
        finish(false);
        return;
      }

      navigator.clipboard.writeText(code).then(function () {
        finish(true);
      }).catch(function () {
        finish(false);
      });
    }

    onEmailSuccess() {
      if (this.emailSent) return;
      this.emailSent = true;
      this.publish('babeina_hub:email_submit', {
        method: 'inline_shopify'
      });
    }
  }

  customElements.define('shine-hub', ShineHub);
}
